import React, {Component} from 'react'
import {connectSortBy} from 'react-instantsearch-dom'
import {getUrlParameterByName,} from '../../../../modules/utils'
import Select from 'react-select'

class SortBy extends Component {
  constructor(props) {
    super(props)
    this.state = {
      sortByPlaceholder: `Sort By`,
      activeFilterIndex: this.determineActiveFilterIndex()
    }
    this.sortbyOptions = this.props.items
  }
  determineActiveFilterIndex() {
    const sort = getUrlParameterByName(`sort`)
    if (sort) {
      const index = this.props.items.findIndex(x => x.label === sort)
      return index
    } else {
      return null
    }
  }

  /**
   * Note: I disagree with this approach. The implementation here can be vastly improved.
   * in short, the Algolia Product Index is being determined by the custom function called changeResultsIndex()
   * then it is being passed up to the Parent Component called '<AlgoliaCollection>' to render out the products
   */
  componentDidMount() {
    const sort = getUrlParameterByName(`sort`)

    // Check if there is a URL param...
    if (sort) {
      const index = this.props.items.findIndex(x => x.label === sort)
      const value = this.props.items[index].value
      const label = this.props.items[index].label

      // This updates Algolia index
      this.props.changeResultsIndex(value)
    }
  }

  handleChange(event, refine) {
    if (event) {
      const { isRefined, label, value } = event
      refine(value)
    }
  }

  render() {
    const { refine } = this.props
    const { sortByPlaceholder, activeFilterIndex } = this.state
    return (
      <div className={`right-view-sort-main`}>
        <div className={`view-main`} data-view={`grid`}>
          <h4>View</h4>
          <div className={`view-inputs`}>
             <input type={`radio`} className="view-input" name={`view`} value="grid" id={`grid`} defaultChecked={true} />
             <label htmlFor={`grid`} className={`grid-label`}></label>
             <input type={`radio`} className="view-input" name={`view`} value="list" id={`list`} />
             <label htmlFor={`list`} className={`list-label`}></label>
          </div>
        </div>
        <div className={`custom-sortby__wrapper custom-sortby-wrapper`}>
           <div className={`compare-price`}>
              <h4>Sort by</h4>
            </div>
          <Select
            className="custom-sortby__select custom-sortby-select"
            classNamePrefix="select"
            defaultValue={
              activeFilterIndex && this.sortbyOptions[activeFilterIndex]
            }
            name="sort-by"
            options={this.sortbyOptions}
            onChange={event => this.handleChange(event, refine)}
            placeholder={sortByPlaceholder}
            isSearchable={false}
          />
        </div>
      </div>
    )
  }
}

const CustomSortBy = connectSortBy(SortBy)

export default CustomSortBy
